module.exports = __webpack_public_path__ + "media/images/logo-email-1db1c51c0a28cadea116ac9a797fa38a.jpg";